export default __webpack_public_path__ + "static/media/phoenix.57585319.png";